import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'

import { epic as authEpic } from './auth'
import billingReducer, { epic as billingEpic } from './billing'
import conversationReducer, { epic as conversationEpic } from './conversation'
import experimentReducer, { epic as experimentEpic } from './experiment'
import geolocationReducer, { epic as geolocationEpic } from './geolocation'
import meetingsReducer, { epic as meetingsEpic } from './meetings'
import { epic as metricsEpic } from './metrics'
import orgReducer, { epic as orgEpic } from './org'
import profileReducer, { epic as profileEpic } from './profile'
import userReducer, { epic as userEpic } from './user'

export const rootReducer = (history) =>
  combineReducers({
    conversation: conversationReducer,
    org: orgReducer,
    user: userReducer,
    profile: profileReducer,
    router: connectRouter(history),
    meetings: meetingsReducer,
    billing: billingReducer,
    geolocation: geolocationReducer,
    experiment: experimentReducer,
  })

export const rootEpic = combineEpics(
  conversationEpic,
  orgEpic,
  profileEpic,
  userEpic,
  meetingsEpic,
  billingEpic,
  geolocationEpic,
  experimentEpic,
  authEpic,
  metricsEpic
)
